import Icon from '@vfz/ui/dist/components/icon/icon';
import { IconName } from '@vfz/ui/dist/components/icon/icon-imports';
import React, { ReactNode } from 'react';

import * as S from './inline-alert.styles';

interface IInlineAlertProps {
  type: 'success' | 'warning' | 'error' | 'info';
  children: ReactNode;
  onClose?: () => void;
  testid?: string;
  fitContent?: boolean;
  alternativeLink?: boolean;
}

export const InlineAlert = ({
  type,
  children,
  onClose,
  testid,
  fitContent = false,
  alternativeLink = false,
  ...rest
}: IInlineAlertProps) => {
  let AlertComponent;
  let iconName: IconName;

  switch (type) {
    case 'error':
      AlertComponent = S.Error;
      iconName = 'alertTriangle';
      break;
    case 'info':
      AlertComponent = S.Info;
      iconName = 'informationCircle';
      break;
    case 'warning':
      AlertComponent = S.Warning;
      iconName = 'alertTriangle';
      break;
    case 'success':
    default:
      AlertComponent = S.Success;
      iconName = 'checkCircle';
      break;
  }

  return (
    <AlertComponent fitContent={fitContent} role="alert" className="inline-alert" data-testid={testid} {...rest}>
      <S.Icon>
        <Icon name={iconName} variant="solid" />
      </S.Icon>
      <S.Content alternativeLink={alternativeLink}>{children}</S.Content>
      {onClose && (
        <S.CloseIcon onClick={onClose}>
          <Icon name="close" width={16} height={16} />
        </S.CloseIcon>
      )}
    </AlertComponent>
  );
};
